import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import { api } from '../helper/api';
import { IPFStoURL, formatPrice } from '../helper/functions';
import { Link, useLocation } from 'react-router-dom';

export default function Collections() {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [collectionData, setCollectionData] = useState([]);
    const [orderBy, setOrderBy] = useState('desc');
    const [orderById, setOrderById] = useState('id');
    const [nfttype, setNfttype] = useState('');
    const [page, setPage] = useState(1);
    const [perpage, setPerpage] = useState(10)
    const [search, setSearch] = useState('')
    const [totalpages, setTotalpages] = useState(0);
    const [categories, setCategories] = useState([]);
    const [categoryId, setCategoryId] = useState(location.state?.categoryId || '');
    const [categoryName, setCategoryName] = useState(location.state?.categoryName || '');
    const [orderByName, setOrderByName] = useState('DESC By Created')
    const [saleTypeName, setSaleTypeName] = useState('')


    useEffect(() => {
        async function fetch() {
            const response = await api.get('collection/categories', {
                params: {
                    limit: 10,
                }
            })

            if (response && response.data && response.data.error === 'OK') {
                setCategories(response.data.data);
            }
        }

        fetch();
    }, []);


    useEffect(() => {
        async function fetch() {
            const response = await api.get('collection/get', {
                params: {
                    order_by: orderBy,
                    order_id: orderById,
                    type: nfttype,
                    page,
                    limit: perpage,
                    search,
                    c_id: categoryId
                }
            })



            if (response && response.data && response.data.error === 'OK') {
                console.log(response.data.data)
                setCollectionData(response.data.data);
                setTotalpages(response.data.totalPages)
            }
            setLoading(false);

        }

        fetch();

        console.log(categoryId)
    }, [perpage, orderBy, nfttype, search, page, orderById, categoryId]);


    const handlePageChange = (nextpage) => {
        let newPage;

        if (nextpage === 'prev' && parseInt(page) - 1 >= 1) {
            newPage = Math.max(1, parseInt(page) - 1);
        } else if (nextpage === 'next' && parseInt(page) < parseInt(totalpages)) {
            newPage = Math.min(parseInt(totalpages), parseInt(page) + 1);
        } else {
            newPage = parseInt(nextpage);
        }

        if (newPage !== parseInt(page)) {
            setPage(newPage);
        }
    };




    return (
        <Layout>
            <section class="jarallax text-light pb-4">
                <div class="center-y relative text-center">
                    <div class="container">
                        <div class="row">

                            <div class="col-md-12 text-center">
                                <h1>NFTs Collections</h1>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='pt-1'>
                <div class="container">
                    <div class="row wow fadeIn">
                        <div class="col-lg-12">

                            <div class="items_filter">
                                <form action="#sec" class="row form-dark" id="form_quick_search">
                                    <div class="col text-center">
                                        <input class="form-control" value={search} onChange={(e) => setSearch(e.target.value)} name="search" placeholder="search item by name or symbol here..." type="text" /> <a href="#sec" id="btn-submit"><i class="fa fa-search bg-color-secondary"></i></a>
                                        <div class="clearfix"></div>
                                    </div>
                                </form>

                                <div class="btn-group mx-2">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                        {orderByName ? orderByName : 'DESC By Created'}
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('desc')
                                            setOrderById('id')
                                            setOrderByName('DESC By Created')
                                        }}><span>DESC By Created</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('asc')
                                            setOrderById('id')
                                            setOrderByName('ASC By Created')
                                        }}><span>ASC By Created</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('asc')
                                            setOrderById('volume')
                                            setOrderByName('ASC By Volume')
                                        }}><span>ASC By Volume</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('desc')
                                            setOrderById('volume')
                                            setOrderByName('DESC By Volume')
                                        }}><span>DESC By Volume</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('asc')
                                            setOrderById('floor_price')
                                            setOrderByName('ASC By Floor Price')
                                        }}><span>ASC By Floor Price</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('desc')
                                            setOrderById('floor_price')
                                            setOrderByName('DESC By Floor Price')
                                        }}><span>DESC By Floor Price</span></li>
                                    </ul>
                                </div>

                                <div class="btn-group mx-2">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                        {saleTypeName ? saleTypeName : 'All'}
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li class="dropdown-item" onClick={() => {
                                            setNfttype('')
                                            setSaleTypeName('All')
                                        }}><span>All</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setNfttype('ERC-721')
                                            setSaleTypeName('Single Items')
                                        }}><span>Single Items</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setNfttype('ERC-1155')
                                            setSaleTypeName('Bundles')
                                        }}><span>Bundles</span></li>
                                    </ul>
                                </div>
                                <div class="btn-group mx-2">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                        {perpage ? perpage : 'Per Page Items'}
                                    </button>

                                    <ul class="dropdown-menu">
                                        <li class="dropdown-item" onClick={() => setPerpage(10)}><span>10</span></li>
                                        <li class="dropdown-item" onClick={() => setPerpage(20)}><span>20</span></li>
                                        <li class="dropdown-item" onClick={() => setPerpage(30)}><span>30</span></li>
                                    </ul>
                                </div>

                                <div class="btn-group mx-2">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                        {categoryName ? categoryName : 'Categories'}
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li class="dropdown-item" onClick={() => {
                                            setCategoryId(1)
                                            setCategoryName("")
                                        }}><span>All</span></li>
                                        {categories && categories.map((items, key) => (
                                            <li class="dropdown-item" key={key} onClick={() => {
                                                setCategoryId(items.id)
                                                setCategoryName(items.name)
                                            }}><span>{items.name}</span></li>
                                        ))}
                                    </ul>
                                </div>

                            </div>
                        </div>
                        {loading ? (
                            <>Loader</>
                        ) : (
                            <>
                                {collectionData && collectionData.map((items, key) => {
                                    return (
                                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={key}>
                                            <div class="nft__item">
                                                <div class="nft__item_wrap">
                                                    <Link to={`/collection/${items.nft_address}`}>
                                                        <img src={IPFStoURL(items.profile)} class="nft__item_preview" alt="static" />
                                                    </Link>
                                                </div>
                                                <div class="nft__item_info">
                                                    <Link to={`/collection/${items.nft_address}`}>
                                                        <h4>{items.name} ({items.symbol})</h4>
                                                    </Link>
                                                    <div className='d-flex justify-content-between mb-3'>
                                                        <div class="nft__item_price">
                                                            <span>Floor Price : {items.floor_price ? formatPrice(items.floor_price / Math.pow(10, 18)) : '0'} BST</span>
                                                        </div>
                                                        <div class="nft__item_action">
                                                            <span>Volume : {items.volume ? formatPrice(items.volume / Math.pow(10, 18)) : '0'} BST</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                {collectionData && collectionData.length > 0 &&
                                    <div className='col-12 d-flex justify-content-center'>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination pagination">
                                                <li>
                                                    <button

                                                        disabled={parseInt(page) === 1 || parseInt(page) === 0} // Disable if on the first page
                                                        onClick={() => handlePageChange('prev')}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>
                                                {Array.from({ length: totalpages }, (_, index) => (
                                                    <li key={index}>
                                                        <button
                                                            className={`${page === index + 1
                                                                ? 'active'
                                                                : ''
                                                                }`}
                                                            onClick={() => handlePageChange(index + 1)}
                                                        >
                                                            {index + 1}
                                                        </button>
                                                    </li>
                                                ))}
                                                <li>
                                                    <button
                                                        disabled={parseInt(page) === parseInt(totalpages)} // Disable if on the last page
                                                        onClick={() => handlePageChange('next')}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                }
                            </>

                        )}
                    </div>
                </div>
            </section>
        </Layout>
    )
}
